import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver, UseFormProps } from 'react-hook-form';
import { z } from 'zod';

export const schemaLanguage = z.object({
  name: z.string().min(1, 'Please enter a valid description.{1}'),
  code: z.string().min(1, 'Please enter a valid description.{1}'),
});

export type LanguageFormEntity = z.infer<typeof schemaLanguage>;

const languageResolver: Resolver<LanguageFormEntity> = zodResolver(schemaLanguage) as never;

export const LanguageFormOptions: UseFormProps<LanguageFormEntity> = {
  mode: 'onSubmit',
  resolver: languageResolver,
};
